<div class="wrapper">
    <app-sidebar></app-sidebar>
    <app-header></app-header>
    <div class="page-wrapper">
        <div class="page-content">
    
            <!--breadcrumb-->
            <div class="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
                <div class="breadcrumb-title pe-3 border-end-0">Dashboard</div>
                <!-- <div class="ps-3">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb mb-0 p-0">
                            <li class="breadcrumb-item"><a href='javascript:void(0)' routerLink='/dashboard'><i class="bx bx-home-alt"></i></a></li>
                        </ol>
                    </nav>
                </div> -->
            </div>
            <!--end breadcrumb-->
    
            <!--Start row-->
            <div class="row row-cols-1 row-cols-md-3 row-cols-xl-5">
                <div class="col" (click)="redirect('/user-listing')" style="cursor: pointer;">
                    <div class="card radius-10">
                        <div class="card-body">
                            <div class="text-center">
                                <div class="widgets-icons rounded-circle mx-auto bg-light-primary text-primary mb-3">
                                    <i class='bx bx-user'></i>
                                </div>
                                <h4 class="my-1 text-white">{{detaildata.userCount}}</h4>
                                <p class="mb-0 text-white"> Total Users </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col"  (click)="redirect('/transaction')"  style="cursor: pointer;">
                    <div class="card radius-10">
                        <div class="card-body">
                            <div class="text-center">
                                <div class="widgets-icons rounded-circle mx-auto bg-light-success text-success mb-3">
                                    <i class='bx bx-wallet'></i>
                                </div>
                                <h4 class="my-1 text-white">{{detaildata.transactionCount}}</h4>
                                <p class="mb-0 text-white">Total Transaction</p>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="col"  (click)="redirect('/report-post')"  style="cursor: pointer;">
                    <div class="card radius-10">
                        <div class="card-body">
                            <div class="text-center">
                                <div class="widgets-icons rounded-circle mx-auto bg-light-danger text-danger mb-3">
                                    <i class='bx bx-wallet'></i>
                                </div>
                                <h4 class="my-1">{{detaildata.reportPostCount}}</h4>
                                <p class="mb-0 text-secondary">Total Report Post</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col"  (click)="redirect('/report-user')"  style="cursor: pointer;">
                    <div class="card radius-10">
                        <div class="card-body">
                            <div class="text-center">
                                <div class="widgets-icons rounded-circle mx-auto bg-light-danger text-danger mb-3">
                                    <i class='bx bx-wallet'></i>
                                </div>
                                <h4 class="my-1">{{detaildata.reportUserCount}}</h4>
                                <p class="mb-0 text-secondary">Total Report User</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col"  (click)="redirect('/interest')"  style="cursor: pointer;">
                    <div class="card radius-10">
                        <div class="card-body">
                            <div class="text-center">
                                <div class="widgets-icons rounded-circle mx-auto bg-light-danger text-danger mb-3">
                                    <i class='bx bx-wallet'></i>
                                </div>
                                <h4 class="my-1">{{detaildata.interestCount}}</h4>
                                <p class="mb-0 text-secondary">Total Interest</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col"  (click)="redirect('/community')"  style="cursor: pointer;">
                    <div class="card radius-10">
                        <div class="card-body">
                            <div class="text-center">
                                <div class="widgets-icons rounded-circle mx-auto bg-light-danger text-danger mb-3">
                                    <i class='bx bx-wallet'></i>
                                </div>
                                <h4 class="my-1">{{detaildata.communityCount}}</h4>
                                <p class="mb-0 text-secondary">Total Community</p>
                            </div>
                        </div>
                    </div>
                </div>
                 -->

                <!-- <div class="col">
                    <div class="card radius-10">
                        <div class="card-body">
                            <div class="text-center">
                                <div class="widgets-icons rounded-circle mx-auto bg-light-info text-info mb-3">
                                    <i class='bx bx-wallet'></i>
                                </div>
                                <h4 class="my-1">$52,945</h4>
                                <p class="mb-0 text-secondary"> Total Income </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="card radius-10">
                        <div class="card-body">
                            <div class="text-center">
                                <div class="widgets-icons rounded-circle mx-auto bg-light-success text-success mb-3">
                                    <i class='bx bx-chat'></i>
                                </div>
                                <h4 class="my-1">869</h4>
                                <p class="mb-0 text-secondary"> Total Comments </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="card radius-10">
                        <div class="card-body">
                            <div class="text-center">
                                <div class="widgets-icons rounded-circle mx-auto bg-light-warning text-warning mb-3">
                                    <i class='bx bxs-group'></i>
                                </div>
                                <h4 class="my-1">42,892</h4>
                                <p class="mb-0 text-secondary">Total Customers</p>
                            </div>
                        </div>
                    </div>
                </div> -->
            </div>
            <!--end row-->
    
    
        </div>
    </div>
    <app-footer></app-footer>
</div>


